module.exports = (s) => {
  return [
    {
      name: 'ID',
      value: 'id',
      width: 60,
    },
    {
      name: '模板名称',
      value: 'name',
    },
    {
      name: '应用模板',
      width: 90,
      format: (row) => {
        const h = s.$createElement;
        const ele = h('el-button',
          {
            props: {
              type: 'text',
            },
            on: {
              click: () => {
                s.confirm(row.template_data);
              },
            },
          },
          '应用模板',
        );

        return ele;
      },
    },
    {
      name: '操作',
      width: 70,
      format: (row) => {
        const h = s.$createElement;
        const ele = h('el-button',
          {
            props: {
              type: 'text',
            },
            style: 'color: #F56C6C',
            on: {
              click: () => {
                s.deleteTemplate(row.id);
              },
            },
          },
          '删除',
        );

        return ele;
      },
    },
  ];
};
